import { Link } from "react-router-dom";

const CustomBreadcrumbs = ({ links, steps }: { links?: string[], steps?: string[] }) => {
    let breadcrumbs: JSX.Element[] = [];

    if (steps) {
        steps?.forEach((step, index) => {
            breadcrumbs.push(
                <span key={`breadcrumb-${step}`}>
                    {index > 0 && <>&nbsp;&gt;&nbsp;</>}
                    {step}
                </span>
            );
        });
    }

    if (links) {
        links?.forEach((link, index) => {
            breadcrumbs.push(
                <span key={`breadcrumb-${link}`}>
                    {index > 0 && <>&nbsp;&gt;&nbsp;</>}
                    <Link to={`/${link}`}>
                        {link}
                    </Link>
                </span>
            );
        });
    }

    return (
        <span className="breadcrumbs">
            {breadcrumbs}
        </span>
    );
};

export default CustomBreadcrumbs;